<template>
	<div class="modal">
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12 w-full">
				<p class="textGrey textLg textCenter">
					Balance History for <strong>{{ account ? account.name : tenant.companyName }}</strong>
				</p>
			</div>
		</div>

		<div class="row margin-b30">
			<div class="w-full">
				<div class="card formPanel">
					<div class="content">
						<p class="textCenter margin-b20 mx-auto">
							Current Balance:
							<strong class="margin-l10">{{
								$global.currencyGbp(account ? account.balanceGbp : tenant.balanceGbp, 2)
							}}</strong>
						</p>
						<div class="row">
							<div v-if="audits.length > 0" class="flex w-full flex-col gap-2">
								<div
									v-for="audit in audits"
									:key="audit.id"
									class="flex w-full flex-col items-center justify-center border-b border-dark p-2 pb-4 last:border-b-0 last:pb-2 dark:border-light"
								>
									<div class="flex w-full flex-col items-center justify-center rounded-sm">
										<p class="font-bold">{{ $global.dateWordFormat(audit.createdAt) }}</p>
										<p class="text-center">{{ audit.description }}</p>
									</div>
									<p v-if="audit.user_notes">
										<span class="font-semibold italic">Notes:</span> "{{ audit.user_notes }}"
									</p>
								</div>
							</div>
							<div v-else class="flex w-full flex-col gap-2">
								<div class="flex w-full justify-center">
									<p class="text-center font-semibold">There is no audit history for this record.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12 mx-auto">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import accountAuditsApi from '@/scripts/accountaudits/accountaudits.api'
import tenantAuditsApi from '@/scripts/tenantaudits/tenantaudits.api'

export default {
	inject: ['user', 'userRoles', 'showBalanceHistoryModal'],
	props: ['tenant', 'account'],

	data() {
		return {
			audits: []
		}
	},

	created() {
		if (this.account)
			accountAuditsApi
				.getAll({
					where: {
						selectedAccount: this.account
					}
				})
				.then((response) => {
					this.audits = response.data.results
				})
		else
			tenantAuditsApi
				.getAll({
					where: {
						selectedTenant: this.tenant.id
					}
				})
				.then((response) => {
					this.audits = response.data.results
				})
	},

	methods: {
		close() {
			this.showBalanceHistoryModal = false
		}
	}
}
</script>
